import React from "react";
import "../About/AboutCta.css";
import { FaPhoneAlt } from "react-icons/fa";

const AboutCta = () => {
  return (
    <section className="about-cta-section">
      <div className="about-cta-wrapper">
        <h2>The World is Waiting</h2>

        <p className="about-cta-text">
          Experience the difference of booking with a team that truly knows the
          world. At Click4Flight, we don't just find flights; we craft journeys.
        </p>

        <div className="about-cta-call">
          <FaPhoneAlt />
          <a href="tel:02033557350  ">02033557350  </a>
        </div>

        <p className="about-cta-subtext">
          Call our Global Travel Desk today for a bespoke quote to any destination
          worldwide.
        </p>
      </div>
    </section>
  );
};

export default AboutCta;